import React from 'react';
import PropTypes from 'prop-types';

import { printMissingConfigError, SiteConfigManager } from '@atlas/core';

const GCLicense = ({ iconHeight = 50, iconWidth = 120 }) => {
  const refererUrl = window.location.origin;
  const GCId = SiteConfigManager.getConfig('config.config.license.GCId');

  if (!GCId) {
    printMissingConfigError('config.config.license.GCId');
  }

  const licenseView =
    window.SYS_CONFIG.env === 'production' ? (
      <a
        aria-label="Gaming Curacao: Click to Validate"
        href={`https://licensing.gaming-curacao.com/validator/?lh=${GCId}`}
        rel={refererUrl}
        target="_blank"
      >
        <img
          alt="Gaming Curacao: Click to Validate"
          border="0"
          height={iconHeight}
          src="https://licensing.gaming-curacao.com/validator/images/Gaming-Curacao-ClickToVerify.png"
          width={iconWidth}
        />
      </a>
    ) : (
      <iframe
        height={iconHeight}
        src={`https://licensing.gaming-curacao.com/validator/?lh=${GCId}&template=tseal`}
        style={{ border: 'none' }}
        title="Gaming Curacao"
        width={iconWidth}
      />
    );

  return <div className="e-gaming-logo e-gaming-logo--custom">{licenseView}</div>;
};

export default function (props) {
  return <GCLicense {...props} />;
}

GCLicense.propTypes = {
  iconHeight: PropTypes.number,
  iconWidth: PropTypes.number,
};
